<template>
  <div class="levo-sirsi__join">
    <div class="levo-sirsi__join__about">
      <div class="levo-sirsi__join__about__img"></div>
    </div>
    <div class="levo-sirsi__join__help">
      <div class="levo-sirsi__join__help__img">
        <div class="levo-sirsi__join__help__img__img"></div>
      </div>
      <a href="mailto:adgame-info@vse.cz" class="levo-sirsi__join__help__text"
        >Help & Support</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "LevoAbout",
};
</script>
